import { Tag } from 'antd';
import React from 'react';

import { TextWithIconTooltip } from '../../../components/TextWithIconTooltip';

export const VendorPasscodeRecommendation: React.FC<any> = () => {
  return (
    <TextWithIconTooltip
      text={(
        <Tag
          style={{ color: 'rgba(0, 0, 0, 0.85)', marginRight: 0 }}
          color='gold'
        >
          Regeneration Recommended
        </Tag>
      )}
      tooltip={{
        title: 'For security purposes, we typically recommend generating a new vendor passcode each year.',
      }}
    />
  );
};
